// Keep decimal API amounts exact; chart coordinates alone use floating point.
export function sumAmounts(values: string[]): string {
  const scale = Math.max(2, ...values.map((value) => (value.split('.')[1] ?? '').length))
  const sum = values.reduce((total, value) => {
    const negative = value.startsWith('-')
    const [whole, fraction = ''] = value.replace(/^[+-]/, '').split('.')
    const amount = BigInt(whole + fraction.padEnd(scale, '0'))
    return total + (negative ? -amount : amount)
  }, 0n)
  const digits = (sum < 0n ? -sum : sum).toString().padStart(scale + 1, '0')
  return `${sum < 0n ? '-' : ''}${digits.slice(0, -scale)}.${digits.slice(-scale)}`
}

export function money(value: string): string {
  const negative = value.startsWith('-')
  const [whole, fraction = ''] = value.replace(/^[+-]/, '').split('.')
  let cents = BigInt(whole || '0') * 100n + BigInt(fraction.padEnd(2, '0').slice(0, 2))
  if (Number(fraction[2] ?? 0) >= 5) cents += 1n
  const digits = cents.toString().padStart(3, '0')
  return `${negative && cents !== 0n ? '-' : ''}${digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${digits.slice(-2)}`
}

export const count = (value: number) => value.toLocaleString('en-US', { maximumFractionDigits: 0 })
